import { SelectField } from '../fields/select.js';
import { OptionsGroup } from '../fields/options-group.js';
import { TextareaField } from '../fields/textarea.js';
import { InputField } from '../fields/input.js';
import { PasswordField } from '../fields/password.js';
import { RangeField } from '../fields/range.js';
import { NumberField } from '../fields/number.js';
var fieldTypes = {
  text: InputField,
  number: NumberField,
  range: RangeField,
  email: InputField,
  password: PasswordField,
  date: InputField,
  search: InputField,
  textarea: TextareaField,
  radio: OptionsGroup,
  checkbox: OptionsGroup,
  "switch": OptionsGroup,
  select: SelectField
};

var getField = function getField(type) {
  var fieldType = type;
  return fieldTypes[fieldType];
};

export { getField };